import { FotoPerfil } from './styles'

const Avatar = () => <FotoPerfil src="https://github.com/georgecmf.png" />

export default Avatar
